import { setCookie, CookieKeys } from "../../../lib/cookies";
import { createAccessToken, setOtpToken } from "../../visitWidgetApi";
import { buildErrorMessage } from "../helpers/buildErrorMessage";
import { AppDispatch } from "@store/store";
import { logInfo } from "@lib/logger";
import { authTokenSuccessAction } from "./authTokenSuccessAction";
import { setAuthViewAction } from "@store/sessionReducer";
export interface LoginActionParams {
  email?: string;
  password?: string;
  otp?: string;
}

/*
 * Login user.
 */
const loginAction =
  ({ email, password, otp }: LoginActionParams) =>
  async (dispatch: AppDispatch) => {
    try {
      const response = await createAccessToken({ email, password, otp });

      if (response.authToken) {
        await dispatch(
          authTokenSuccessAction({ authToken: response.authToken }),
        );
      } else if (response.otpToken) {
        setCookie(CookieKeys.otpToken, response.otpToken);
        setOtpToken(response.otpToken);
        dispatch(setAuthViewAction({ authView: "adminOtpVerify" }));
      } else {
        logInfo(response.errors);
      }
    } catch (error) {
      const errorMessage = buildErrorMessage(error as any);
      logInfo(errorMessage);
      throw error;
    }
  };

export { loginAction };
